import React, { useCallback, useContext, useEffect, useRef, useState } from "react";
import { UNSAFE_NavigationContext as NavigationContext } from "react-router-dom";
import ActionModal from "../components/Modals/ActionModals/ActionModal";
import { useTranslation } from "react-i18next";


export function usePrompt(message: string, when: boolean) {
  const { navigator } = useContext(NavigationContext);
  const [showModal, setShowModal] = useState(false);
  const [nextLocation, setNextLocation] = useState<any>(null);
  const [retry, setRetry] = useState<(() => void) | null>(null);
  const { t, i18n } = useTranslation();

  const blocker = useRef<((tx: any) => void) | null>(null);

  const confirmExit = useCallback(
    (tx: any) => {
      setShowModal(true);
      setNextLocation(tx.location);
      setRetry(() => () => {
        setShowModal(false);
        tx.retry(); // allow navigation
      });
    },
    []
  );

  useEffect(() => {
    if (!when) return;

    const push = navigator.push;

    navigator.push = (...args: Parameters<typeof push>) => {
      confirmExit({
        location: args[0],
        retry: () => push(...args),
      });
    };

    return () => {
      navigator.push = push;
    };
  }, [navigator, confirmExit, when]);

  // Show ActionModal component
  const modal = (
    <ActionModal
      active={showModal}
      title={t("global.unsavedChanges.title")}
      onCancel={() => {
        setShowModal(false);
        setNextLocation(null);
      }}
      onConfirm={() => {
        retry?.();
      }}
      func={async () => Promise.resolve()}
      hideOnConfirm={true}
      positiveButton={{ text: t("global.operations.confirm"), variant: "danger" }}
      negativeButtonText={t("global.operations.cancel")}
    >
      {t("global.unsavedChanges.message")}
    </ActionModal>
  );

  return modal;
}
